(async () => {
  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const truncate = (string) => {
    if (string.length > 67) return string.substring(0, 67) + '...';
    return string;
  };
  const renderOOSIcon = (color) => {
    return `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="${color}"
        height="auto"
        width="auto"
        version="1.1"
        viewBox="0 0 460.775 460.775"
        xml:space="preserve"
        style="height: 100%; width: 100%; display: block;"
      >
        <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55  c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55  c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505  c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55  l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719  c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/>
      </svg>
    `;
  };
  const renderAuthIcon = (selector) => {
    return `
        <div style="width:100%; height: 100%" class="${selector}">
            <img
                src="https://cdn.shopify.com/s/files/1/1163/1976/files/authorized-check.png?v=1665167039"
                alt="Delivery Truck"
                height="50"
                width="50"
                loading="eager"
                style="width: 100%; height: 100%; object-fit: contain; filter: brightness(0);"
            >
        </div>
        <style>
        .cart__icon--authorized--lime {
            filter: invert(67%) sepia(47%) saturate(682%) hue-rotate(65deg) brightness(91%) contrast(86%) drop-shadow(1px 1px 1px rgb(0,0,0,0.15));
        }
        .cart__icon--authorized--blue {
            filter: invert(45%) sepia(12%) saturate(1619%) hue-rotate(173deg) brightness(97%) contrast(95%) drop-shadow(1px 1px 1px rgb(0,0,0,0.15));
        }
        .icon--filter-white {
            filter: brightness(0) invert(1);
        }
        </style>
        `;
  };
  const renderPreOrderIcon = () => {
    return `<img
      src="https://cdn.shopify.com/s/files/1/1163/1976/files/preorder-icon_789aaab2-b3fc-4fa8-b2b8-e5e2ec722858.png?v=1665510873"
      alt="preorder icon"
      width="auto"
      height="auto"
      loading="lazy"
      style="width: 100%; height: 100%; object-fit: contain;"
    />`;
  };
  const getShippingMessage = (productShipping, collectionShipping) => {
    if (productShipping.pdp_line_1) {
      if (
        productShipping.pdp_line_1.includes(':') ||
        productShipping.pdp_line_1?.toUpperCase().includes('ADD TO CART')
      ) {
        return productShipping.pdp_line_2;
      } else {
        return productShipping.pdp_line_1;
      }
    }
    if (collectionShipping.pdp_line_1) {
      if (
        collectionShipping.pdp_line_1.includes(':') ||
        collectionShipping.pdp_line_1?.toUpperCase().includes('ADD TO CART')
      ) {
        return collectionShipping.pdp_line_2;
      } else {
        return collectionShipping.pdp_line_1;
      }
    }
    return 'Ships same or next day';
  };
  const recentAnchor = document.querySelector('.js-recent-anchor');
  const recentlyViewedProducts = localStorage.getItem('recently_viewed')
    ? JSON.parse(localStorage.getItem('recently_viewed'))
    : [];
  let reformatting = false;
  for (let product of recentlyViewedProducts) {
    if (!product.firstVariantId) {
      reformatting = true;
      localStorage.setItem('recently_viewed', JSON.stringify([]));
    }
  }
  const recentPdpShow =
    (window.location.pathname.includes('product') && recentlyViewedProducts.length > 1) ||
    (!window.location.pathname.includes('product') && recentlyViewedProducts.length > 0);
  if (recentlyViewedProducts && recentPdpShow && !reformatting) {
    const handles = recentlyViewedProducts.map((p) => p.handle);
    fetch(`https://www.fpapplications.com/recent?currency=${CURRENCY_CODE}&handles=${handles.join(',')}`)
      .then((res) => res.json())
      .then((res) => {
        if (res) {
          for (let i = 0; i < res.length; i++) {
            const product = res[i];
            const title = truncate(product.title);
            const url = `/products/${product.handle}`;
            const id = recentlyViewedProducts[i].firstVariantId;
            const image = product.img_src;
            const badge = product.reviews_badge;
            const price = product.price;
            const compareAtPrice = product.compare_at_price;
            const available =
              product.calculated_published &&
              ((product.inventory_quantity > 0 && product.tracks_inventory === 1) ||
                product.tracks_inventory === 0 ||
                product.inventory_policy === 'continue');
            const preorder =
              product.inventory_policy === 'continue' &&
              product.tracks_inventory === 1 &&
              product.inventory_quantity <= 0;
            const shipping = product.custom_processing_time ? JSON.parse(product.custom_processing_time) : {};
            const collectionShipping = product.vendor_processing_time ? JSON.parse(product.vendor_processing_time) : {};
            const onSale =
              (shipping.pdp_line_1 && shipping.pdp_line_1.includes(':')) ||
              (!shipping.pdp_line_1 && collectionShipping.pdp_line_1 && collectionShipping.pdp_line_1.includes(':')) ||
              compareAtPrice;
            const shippingMessage = getShippingMessage(shipping, collectionShipping);
            const newSlide = document.createElement('li');
            newSlide.classList.add('recent__grid__slide', 'splide__slide');
            newSlide.innerHTML = `
                  <div class="recent__grid__slide__card">
                    <a href="${url}" class="recent__grid__slide__image-container">
                      <img
                        class="recent__grid__slide__img"
                        src="${image}"
                        alt="${title}"
                        width="300"
                        height="300"
                        loading="lazy"
                      />
                    </a>
                    <a href="${url}" class="recent__grid__slide__heading">${title}</a>
                    ${badge}
                    <div class="recent__grid__slide__price-box">
                      <p class="recent__grid__slide__price">${moneyFormatter.format(price)}</p>
                      ${
                        compareAtPrice
                          ? `<p class="recent__grid__slide__price--compare">${moneyFormatter.format(
                              compareAtPrice
                            )}</p>`
                          : ''
                      }
                    </div>
                    <div class="recent__grid__slide__stock">
                      ${
                        preorder
                          ? `<div class="recent__grid__slide__stock--icon">
                          ${renderPreOrderIcon()}
                        </div><span class="recent__grid__slide__stock--text">Pre Order</span>`
                          : available
                          ? `<div class="recent__grid__slide__stock--icon">${renderAuthIcon(
                              'cart__icon--authorized--blue'
                            )}</div><span class="recent__grid__slide__stock--text">In Stock</span>`
                          : `<div class="recent__grid__slide__stock--icon" style="padding: 4px">${renderOOSIcon(
                              'rgb(180,0,0)'
                            )}</div><span class="recent__grid__slide__stock--text" style="color:rgb(180,0,0)">Out Of Stock</span>`
                      }
                    </div>
                      ${
                        shippingMessage
                          ? `<p class="recent__grid__slide__shipping__message">${shippingMessage}</p>`
                          : ''
                      }
                      ${
                        available
                          ? '<button type="button" class="recent__atc">Add To Cart</button>'
                          : '<button type="button" class="recent__atc recent__atc--out-of-stock">Out Of Stock</button>'
                      }
                      ${onSale ? `<div class="recent__sale"><div class="recent__sale__inner">SALE</div></div>` : ''}
                  </div>
                `;
            newSlide.querySelector('button').addEventListener('click', () => {
              if (available) {
                newSlide.querySelector('button').innerText = 'Adding...';
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    items: [
                      {
                        id,
                        quantity: 1,
                      },
                    ],
                  }),
                })
                  .then(() => {
                    if (window.slideout) {
                      window.slideout.refresh().then(() => {
                        window.slideout.showCart();
                        newSlide.querySelector('button').innerText = 'ADD TO CART';
                      });
                    } else {
                      window.location.href = '/cart';
                      newSlide.querySelector('button').innerText = 'ADD TO CART';
                    }
                  })
                  .catch(() => {
                    newSlide.querySelector('button').innerText = 'Unable To Add';
                  });
              }
            });
            recentAnchor.append(newSlide);
            const recentSplider = new Splide('.js-recent-splide', {
              type: 'slide',
              rewind: true,
              rewindByDrag: true,
              rewindSpeed: 1500,
              perPage: 5,
              perMove: 1,
              pagination: false,
              breakpoints: {
                650: {
                  perPage: 1,
                },
                900: {
                  perPage: 2,
                },
                1200: {
                  perPage: 3,
                },
                1350: {
                  perPage: 4,
                },
              },
            }).mount();
            if (recentlyViewedProducts.length <= 1) {
              recentSplider.destroy();
            }
          }
          document.querySelector('.js-recent').style.minHeight = '';
        } else {
          document.querySelector('.js-recent').remove();
        }
      })
      .catch((err) => {
        document.querySelector('.js-recent').remove();
      });
  } else {
    document.querySelector('.js-recent').remove();
  }
})();
